module.exports = __webpack_public_path__ + "img/pzlx2@3x.ace29ce3.png";